import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigService } from '../../services/config/config.service';

interface EnvironmentConfig {
  label: string;
  color: string;
  show: boolean;
}

@Component({
  selector: 'app-environment-indicator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './environment-indicator.component.html',
  styleUrl: './environment-indicator.component.scss'
})
export class EnvironmentIndicatorComponent implements OnInit {
  currentEnvironment = signal<string>('');
  environmentConfig = signal<EnvironmentConfig | null>(null);
  productionFlag = signal<boolean>(false);

  private readonly environmentConfigs: Record<string, EnvironmentConfig> = {
    'ci': { label: 'CI', color: 'orange', show: true },
    'qa': { label: 'QA', color: 'blue', show: true },
    'stage': { label: 'STAGE', color: 'green', show: true },
    'production': { label: '', color: '', show: false }, // Hidden in production
    'prod': { label: 'PROD', color: '', show: false },// Hidden in production
    'dev': { label: 'DEV', color: 'gray', show: true } ,
    "int": { label: 'INT', color: 'cyan', show: true }
  };

  constructor(private configService: ConfigService) {}

  ngOnInit(): void {
    this.loadEnvironment();
  }

  private loadEnvironment(): void {
    try {
      // get production flag from config
      const productionFlag = this.configService.getConfigProperty('production') as boolean;
      this.productionFlag.set(productionFlag);
      
      const environment = this.configService.getConfigProperty('environment') as string;
      
      const normalizedEnv = environment?.toLowerCase() || '';
      
      this.currentEnvironment.set(normalizedEnv);
      
      const config = this.environmentConfigs[normalizedEnv];
      this.environmentConfig.set(config);
    } catch (error) {
      console.warn('Failed to load environment configuration:', error);
      // Don't show anything if config fails - safer for production
      this.currentEnvironment.set('');
      this.environmentConfig.set(null);
    }
  }

  shouldShowIndicator(): boolean {
    const config = this.environmentConfig();
    return config?.show ?? false;
  }

  getEnvironmentLabel(): string {
    const config = this.environmentConfig();
    return config?.label || '';
  }

  getEnvironmentColor(): string {
    const config = this.environmentConfig();
    return config?.color || 'gray';
  }
} 